/**************************************************************************
* IMPORTS
***************************************************************************/

// NPM: MAIN
import Vue from 'vue'
import VueAxios from 'vue-axios';
import axios from '@/wrappers/axios.js';

Vue.use(VueAxios, axios);

import App from './App.vue'
import router from './router'
import store from './store';
import './plugins/buefy';
import './plugins/auth';
import './helpers/filters';
import './helpers/mixins';
import './services';

import ErrorMessage from '@/components/ErrorMessage'
Vue.component('ErrorMessage', ErrorMessage)
import SuccessMessage from '@/components/SuccessMessage'
Vue.component('SuccessMessage', SuccessMessage)

Vue.config.productionTip = false

// ---------------------------------------------------
// START Auth0 configuration
// ---------------------------------------------------

import { Auth0Plugin, getInstance } from "./plugins/auth.js";

Vue.use(Auth0Plugin, {
  "domain": process.env.VUE_APP_AUTH0_DOMAIN,
	"audience": process.env.VUE_APP_AUTH0_AUDIENCE,
	"clientId": process.env.VUE_APP_AUTH0_CLIENT_ID,
	"redirectUri": window.location.origin ,
  onRedirectCallback: appState => {
    // window.console && console.log('[Auth0][onRedirectCallback][state]');
    // window.console && console.log(appState);
    if (appState && appState.targetUrl) {
      router.push(appState.targetUrl)
        .then(() => {
          mountApp();
        })
        .catch(err => {
          alert(err)
        });
    }
    else {
      mountApp();
    }
  }
});

// This is more useful for debugging during development where we
// are more likely to stop/refresh pages while handling auth.
// (otherwise error is hidden until you go looking for it)
(function() {
  const instance = getInstance();
  instance.$watch('error', error => {
    if (error) {
      alert(`Unexpected Auth0 error: ${error.message}`);
    }
  });
})();

// ---------------------------------------------------
// END Auth0 configuration
// ---------------------------------------------------

// ---------------------------------------------------
// START Function to call when ready to mount Vue
// ---------------------------------------------------

function mountApp () {
  new Vue({
    store: store,
    router: router,
    render: h => h(App),
  }).$mount('#app')
}

// ---------------------------------------------------
// END Function to call when ready to mount Vue
// ---------------------------------------------------

// ---------------------------------------------------
// FINALLY Launch app only when authentication is ready
// ---------------------------------------------------

(function() {

  if (window.location.search.includes("code=")
    && window.location.search.includes("state=")) {
      // Do nothing here. The Auth0 onRedirectCallback
      // function must be setup to call mountApp().
  }
  else {

    if ( ! Auth0Plugin.loading) {
      mountApp();
    }
    else {
      const unwatch = Auth0Plugin.$watch('loading', loading => {
        if (loading === false) {
          unwatch();
          mountApp();
        }
      })
    }
  }

})();

// ---------------------------------------------------
// END Launch app only when authentication is ready
// ---------------------------------------------------
